<template lang='pug'>
  select.select(
    v-model="valueBind"
    :class="[`h-${size}`, {'select--default': !valueBind }]"
    :disabled="disabled"
    :id="id"
    :name="id"
    :value="valueBind"
    @input="onSelect($event.target.value)"
  )
    option(value="" disabled selected hidden) Selecione
    option(
      v-for='option in options'
      :value='option.value || option'

    ) {{ option.label || option }}
</template>

<script>
export default {
  name: 'Select',
  data () {
    return {
      valueBind: this.value,
      filled: false
    }
  },
  watch: {
    value (oldValue, newValue) {
      if (oldValue !== newValue) {
        this.valueBind = oldValue
        this.onSelect(this.valueBind)
      }
    }
  },
  created () {
    if (this.value) this.filled = true
  },
  updated () {
    if (this.value) this.filled = true
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      default: () => [
        {
          value: 1,
          label: 'Selecione'
        }
      ]
    },
    size: {
      type: String,
      default: 'medium'
    },
    value: {
      default: ''
    }
  },
  methods: {
    onSelect (value) {
      this.$emit('onChange', value)
      this.filled = value !== ''
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "@/assets/style/_variables";

  .select {
    appearance: none;
    background: #ffffff url('~@/assets/icons/arrow.svg') no-repeat right 16px center/16px;
    border: solid 1px #bdc2c6;
    border-radius: 8px;
    color: #444444;
    cursor: pointer;
    font-family: $rubik-font-family;
    font-size: 16px;
    padding: 8px 40px 8px 16px;
    width: 100%;

    &:active,
    &:focus {
      outline: none;
    }

    &:-webkit-autofill {
      box-shadow: 0 0 0px 1000px #fff inset;
    }

    &:-ms-expand {
      display: none;
    }

    &:disabled {
      cursor: no-drop;
      opacity: 0.4;
    }

    &--default {
      color: rgba(142, 142, 147, 0.6);
    }
  }
</style>
